import { Flag } from '@neo/primitives/icon'
import { REGIONS } from 'v2/configs/constants'

export const OrgFlag = ({ region }: { region: string }) => (
  <span className="flex size-6 shrink-0 items-center justify-center rounded-full">
    <Flag iso={region === REGIONS.IN ? 'IN' : 'US'} circle size={20} />
  </span>
)
